import '../../../assets/css/reset.css';
import '../../../assets/css/common.css';
import '../test-common.css';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import EmblaCarousel from 'embla-carousel';
import {
  getInfoOfDeviceOS,
  getQuerystring,
  getUserDataInTest,
  OLD_API_URL,
  requestGET
} from '../../../assets/js/common-es6';
import { locationMovement } from '../../../components/utils/locationMovement';
import { cashWalkBridgeConfig } from '../../../components/utils/cashWalkBridgeConfig';
import { trostBridgeConfig } from '../../../components/utils/trostBridgeConfig';
import { firebaseEventKey } from '../../../components/utils/firebaseEventKey';

const isApp = getQuerystring('isApp');
const app = getQuerystring('app');
let accessToken = '';
let accessTokenExpiredAt = '';
let refreshToken = '';
let refreshTokenExpiredAt = '';

if (isApp) {
  sessionStorage.isApp = true;
  sessionStorage.app = app;

  accessToken = getQuerystring('accessToken') ?? '';
  accessTokenExpiredAt = getQuerystring('accessTokenExpiredAt') ?? '';
  refreshToken = getQuerystring('refreshToken') ?? '';
  refreshTokenExpiredAt = getQuerystring('refreshTokenExpiredAt') ?? '';
}

const shareTest = document.getElementsByClassName('share-test')[0];
const shareResult = document.getElementsByClassName('share-result')[0];

let shareID = getQuerystring('shareId');
const isPaid = getQuerystring('isPaid');
let pointEl = '';
let answerEl = '';
let answerString = [];
const resultData = [];
let totalPoint = 0;
const shareTotalPoint = getQuerystring('shareTotalPoint') || getQuerystring('point');
const curationOptions = {
  dragFree: false,
  loop: true
};

// VERSION: 2025-01-FIXED
// 하위범주 점수 저장
const categoryScores = {
  '정서': [],
  '무쾌감': [],
  '수면': [],
  '식욕/체중': [],
  '피로/에너지': [],
  '정신운동': [],
  '주의·집중': [],
  '대인관계': [],
  '일상기능': [],
  '자살사고': []
};
// console.log('✓ 스크립트 버전: 2025-01-FIXED 로드됨');

// 상위범주 매핑
const upperCategoryMapping = {
  '감정·동기': ['정서', '무쾌감'],
  '생리·신체활성': ['수면', '식욕/체중', '피로/에너지', '정신운동'],
  '인지': ['주의·집중'],
  '사회·역할기능': ['대인관계', '일상기능']
};

// 하위범주 평균 계산 함수
function calculateSubCategoryAverage(subCategory) {
  if (categoryScores[subCategory] && categoryScores[subCategory].length > 0) {
    const scores = categoryScores[subCategory];
    return scores.reduce((a, b) => a + b, 0) / scores.length;
  }
  return 0;
}

// 상위범주 평균 계산 (소속 하위범주들의 전체 평균)
function calculateUpperCategoryAverage(upperCategory) {
  const subCategories = upperCategoryMapping[upperCategory];
  let totalScore = 0;
  let totalCount = 0;

  for (const subCategory of subCategories) {
    if (categoryScores[subCategory] && categoryScores[subCategory].length > 0) {
      const scores = categoryScores[subCategory];
      totalScore += scores.reduce((a, b) => a + b, 0);
      totalCount += scores.length;
    }
  }

  return totalCount > 0 ? totalScore / totalCount : 0;
}

// 결과 유형 결정 함수
function determineResultType() {
  // console.log('=== 결과 유형 결정 시작 ===');
  // console.log('카테고리별 점수:', categoryScores);

  // 각 하위범주 평균 계산 및 출력
  // console.log('하위범주별 평균:');
  for (const [subCategory, scores] of Object.entries(categoryScores)) {
    if (scores.length > 0) {
      const avg = calculateSubCategoryAverage(subCategory);
      // console.log(`  ${subCategory}: ${avg.toFixed(2)}점 (${scores.length}개 응답)`);
    }
  }

  // 자살사고 체크 (문항 37번, 4점 이상)
  if (categoryScores['자살사고'].length > 0 && categoryScores['자살사고'][0] >= 4) {
    // console.log('→ 자살사고 점수 4점 이상 → 유형 17 (마음의 긴급 SOS)');
    return 17; // 마음의 긴급 SOS 유형
  }

  // 4점 이상인 상위범주 찾기 (소속 하위범주 중 하나라도 4점 이상이면)
  const highScoreCategories = [];
  const upperCategories = ['감정·동기', '생리·신체활성', '인지', '사회·역할기능'];

  // console.log('\n상위범주별 평균 및 4점 이상 여부:');
  for (const upperCategory of upperCategories) {
    const average = calculateUpperCategoryAverage(upperCategory);
    const isHigh = average >= 4;
    // console.log(`  ${upperCategory}: ${average.toFixed(2)}점 ${isHigh ? '✓ 4점 이상' : '(4점 미만)'}`);
    if (isHigh) {
      highScoreCategories.push(upperCategory);
    }
  }

  // 4점 이상인 상위범주가 있는 경우
  if (highScoreCategories.length > 0) {
    // 정렬하여 일관된 키 생성 (한글 가나다순)
    const sortedCategories = highScoreCategories.sort((a, b) => a.localeCompare(b, 'ko'));
    const categoriesKey = sortedCategories.join('+');

    // console.log(`4점 이상 범주: [${sortedCategories.join(', ')}]`);
    // console.log(`범주 조합 키: "${categoriesKey}"`);

    // 조합에 따른 결과 유형 매핑 (2~16번)
    // 한글 가나다순 정렬: 감정·동기 → 사회·역할기능 → 생리·신체활성 → 인지
    const combinationMapping = {
      // 단일 범주 (2~5번)
      '감정·동기': 2,                                      // 마음 감기 유형
      '생리·신체활성': 3,                                  // 방전된 배터리 유형
      '인지': 4,                                          // 머릿속 안개 유형
      '사회·역할기능': 5,                                  // 동굴 속 휴식 유형

      // 2개 조합 (6~11번)
      '감정·동기+생리·신체활성': 6,                        // 젖은 솜이불 유형
      '감정·동기+인지': 7,                                // 마음따로 머리따로 유형
      '감정·동기+사회·역할기능': 8,                        // 커튼 친 방 유형
      '생리·신체활성+인지': 9,                            // 저전력 모드 유형
      '사회·역할기능+생리·신체활성': 10,                  // 강제 동면 유형
      '사회·역할기능+인지': 11,                           // 길 잃은 여행자 유형

      // 3개 조합 (12~15번)
      '감정·동기+생리·신체활성+인지': 12,                 // 내부 시스템 방전 유형
      '감정·동기+사회·역할기능+생리·신체활성': 13,        // 세상과의 거리두기 유형
      '감정·동기+사회·역할기능+인지': 14,                 // 엉킨 실타래 유형
      '사회·역할기능+생리·신체활성+인지': 15,             // 기능 정지 번아웃 유형

      // 4개 전체 조합 (16번)
      '감정·동기+사회·역할기능+생리·신체활성+인지': 16     // 종합 번아웃 유형
    };

    const resultType = combinationMapping[categoriesKey];

    if (resultType) {
      // console.log(`→ 결과 유형 ${resultType}번 매칭 성공!`);
      return resultType;
    } else {
      // console.error(`! 경고: 조합 "${categoriesKey}"에 매칭되는 결과 유형이 없습니다. 기본값 1번 반환.`);
      return 1;
    }
  }

  // console.log('4점 이상 범주 없음 → 전체 평균으로 판단');

  // 4점 이상 범주 없음 - 전체 평균으로 판단
  const allScores = [];
  Object.values(categoryScores).forEach(scores => {
    if (scores.length > 0) {
      allScores.push(...scores);
    }
  });

  const totalAverage = allScores.length > 0 ?
    allScores.reduce((a, b) => a + b, 0) / allScores.length : 0;

  // console.log(`전체 평균: ${totalAverage}점`);

  if (totalAverage >= 2 && totalAverage < 4) {
    // console.log('→ 유형 18 (마음 환기 필요 유형)');
    return 18; // 마음 환기 필요 유형
  }

  // console.log('→ 유형 1 (균형 잡힌 웰니스 유형)');
  return 1; // 균형 잡힌 웰니스 유형
}

const questionData = {
  title: '우울 유형 검사 <br/><strong>나는 우울할 때 어떻게 행동하고 생각할까?</strong>',
  question: [
    [
      '질문',
      [
        '답변'
      ]
    ],
    [
      '대부분의 시간 기분이 가라앉는다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '정서'
    ],
    [
      '하루를 시작할 때부터 기분이 유난히 우울하다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '정서'
    ],
    [
      '슬픈 감정이 온종일 계속된다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '정서'
    ],
    [
      '마음이 답답하고 기분 전환이 잘 되지 않는다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '정서'
    ],
    [
      '평소 즐기던 일에 흥미가 없다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '무쾌감'
    ],
    [
      '무엇을 해도 예전만큼 즐겁지 않다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '무쾌감'
    ],
    [
      '관심 있던 활동조차 하고 싶은 마음이 들지 않는다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '무쾌감'
    ],
    [
      '미래의 일에 대해 기대감이 느껴지지 않는다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '무쾌감'
    ],
    [
      '잠들기까지 시간이 오래 걸린다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '수면'
    ],
    [
      '잠자는 도중에 자주 깨어난다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '수면'
    ],
    [
      '새벽에 일찍 깨고 다시 잠들지 못한다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '수면'
    ],
    [
      '평소보다 과하게 잠을 자고 싶다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '수면'
    ],
    [
      '식욕이 줄어들어 식사가 부담된다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '식욕/체중'
    ],
    [
      '배고픔을 거의 느끼지 못한다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '식욕/체중'
    ],
    [
      '평소보다 음식을 더 많이 먹게 된다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '식욕/체중'
    ],
    [
      '의도치 않게 체중이 눈에 띄게 늘거나 줄었다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '식욕/체중'
    ],
    [
      '작은 일에도 쉽게 지치게 된다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '피로/에너지'
    ],
    [
      '아침에 몸을 일으키기가 힘들다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '피로/에너지'
    ],
    [
      '무언가를 시작할 만한 정신적 에너지가 부족하다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '피로/에너지'
    ],
    [
      '충분히 쉬어도 피로가 풀리지 않는다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '피로/에너지'
    ],
    [
      '움직임이 느려지고 동작이 굼떠진다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '정신운동'
    ],
    [
      '다른 사람의 말에 즉각 반응하기가 어렵다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '정신운동'
    ],
    [
      '안절부절못하고 가만히 앉아 있기가 어렵다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '정신운동'
    ],
    [
      '초조해서 자꾸 손을 만지작거리거나 몸을 움직인다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '정신운동'
    ],
    [
      '일에 집중이 오래 유지되지 않는다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '주의·집중'
    ],
    [
      '생각이 흐려 판단이 더뎌진다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '주의·집중'
    ],
    [
      '간단한 결정도 쉽게 미루게 된다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '주의·집중'
    ],
    [
      '최근에 있었던 일이 잘 기억나지 않는다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '주의·집중'
    ],
    [
      '다른 사람들과 어울리는 것이 힘들게 느껴진다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '대인관계'
    ],
    [
      '다른 사람과 마주치고 싶지 않아 혼자 있으려 한다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '대인관계'
    ],
    [
      '다른 사람과 대화하고 싶은 마음이 들지 않는다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '대인관계'
    ],
    [
      '관계를 유지하는 것이 큰 짐처럼 느껴진다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '대인관계'
    ],
    [
      '일상적인 과제나 업무를 처리하는 것이 어렵다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '일상기능'
    ],
    [
      '집안일이나 업무가 자꾸 밀려 버린다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '일상기능'
    ],
    [
      '업무나 과제를 수행하는 데 평소보다 시간이 더 오래 걸린다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '일상기능'
    ],
    [
      '규칙적인 생활 습관을 유지하는 것이 어렵다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '일상기능'
    ],
    [
      '삶을 끝내고 싶다는 생각이 스친다',
      [
        '전혀 그렇지 않다/1',
        '거의 그렇지 않다/2',
        '보통이다/3',
        '그렇다/4',
        '매우 그렇다/5'
      ],
      'continue',
      '자살사고'
    ],
    {
      title: '우울 유형 검사 결과',
      content: {
        1: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_good.png',
          '균형 잡힌 웰니스 유형 🌿',
          '<p>전반적으로 안정적인 상태를 잘 유지하고 계신 것 같아요. 스스로의 힘으로 마음의 균형을 잘 찾아가고 있다는 긍정적인 신호예요.</p><p><strong>• 감정·동기 (정서, 무쾌감)</strong><br/>기분이나 즐거움, 의욕 면에서 큰 어려움 없이 건강한 마음을 잘 돌보고 있어요.</p><p><strong>• 생리·신체활성 (수면, 식욕/체중, 피로/에너지, 정신운동)</strong><br/>수면, 식사, 에너지 수준 등 신체적인 컨디션도 균형을 잘 잡고 있네요.</p><p><strong>• 인지 (주의·집중)</strong><br/>일상 속에서 집중력을 유지하고 명확하게 생각하는 데에도 어려움이 없어 보여요.</p><p><strong>• 사회·역할기능 (대인관계, 일상기능)</strong><br/>주변 사람들과의 관계를 편안하게 느끼고, 일상적인 역할도 무리 없이 잘 해내고 있어요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• 소소한 즐거움으로 마음 채우기</strong><br/>평소 즐겨 하는 취미 활동을 위한 시간을 따로 내보거나, 하루 중 감사했던 일 3가지를 간단히 기록해 보세요.</p><p><strong>• 건강한 생활 리듬 지키기</strong><br/>매일 비슷한 시간에 잠들고 일어나는 습관은 꾸준한 에너지 유지에 중요해요.</p><p><strong>• 생각을 명료하게 하는 습관</strong><br/>잠시 하던 일을 멈추고 5분 정도 차분히 호흡에 집중하는 명상 시간을 가져보세요.</p><p><strong>• 주변 사람들과 연결되기</strong><br/>가까운 친구나 가족에게 먼저 연락해서 안부를 묻거나, 함께 식사하는 시간을 가져보세요.</p>'
        ],
        2: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_soso.png',
          '마음 감기 유형 💧',
          '<p>마음의 에너지가 많이 소진되어, 감정을 조절하고 일상에서 즐거움을 느끼는 데 어려움을 겪고 계신 것 같아요.</p><p><strong>감정·동기 (정서, 무쾌감) 영역</strong><br/>세상의 색깔이 바랜 것처럼 느껴지는 것과 비슷해요. 마음을 짓누르는 우울하고 답답한 감정의 안개가 걷히지 않고, 예전에는 분명 즐거웠던 활동들에서 더 이상 아무런 재미나 흥미를 느끼지 못하는 상태를 의미해요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• 하루 5분, 햇볕과 인사하기 ☀️</strong><br/>아침에 일어나 창가에서 5분만이라도 햇볕을 쬐어보세요. 햇볕은 세로토닌 분비를 촉진해요.</p><p><strong>• 성취가 아닌 \'행동\'에만 의미 두기</strong><br/>행동의 결과가 아닌 과정 자체에만 집중해 보세요. \'음악 재생 버튼 누르기\'까지만 목표로 삼는 거예요.</p><p><strong>• 내 감정에 이름 붙여주기</strong><br/>\'지금 내가 슬픔을 느끼고 있구나\'라고 속으로 이름을 붙여주세요.</p><p><strong>• 전문가의 도움을 고려해 보기</strong><br/>이런 감정의 어려움이 오랫동안 계속된다면, 전문가의 도움을 받는 것이 가장 안전하고 효과적인 길이에요.</p>'
        ],
        3: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_soso.png',
          '방전된 배터리 유형 🔋',
          '<p>요즘 몸이 보내는 여러 가지 신호 때문에 많이 힘드셨을 것 같아요.</p><p><strong>생리·신체활성 영역</strong><br/>몸의 기본 설정값이 흔들리는 것과 같아요. 수면, 식욕, 에너지의 리듬이 깨지면서 일상생활의 활력이 크게 떨어진 상태를 의미해요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'수면 리셋\' 대신 \'기상 리셋\'☀️</strong><br/>아침에 일어나는 시간을 매일 최대한 비슷하게 맞춰보세요.</p><p><strong>• \'영양\'보다 \'규칙\'에 집중한 식사🍌</strong><br/>작은 바나나 한 개, 요거트 하나도 괜찮아요. 정해진 시간에 무언가라도 먹는 습관이 중요해요.</p><p><strong>• 가장 부드러운 움직임, \'5분 스트레칭\'</strong><br/>5분만 목, 어깨, 허리를 가볍게 돌려주는 스트레칭을 해보세요.</p><p><strong>• 전문가의 도움을 고려해 보기</strong><br/>몸의 불편감이 오랫동안 지속된다면, 전문가의 도움을 받는 것을 고려해 보세요.</p>'
        ],
        4: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_soso.png',
          '머릿속 안개 유형 🌫️',
          '<p>요즘 머릿속에 안개가 낀 것처럼 답답하고, 생각이 예전처럼 빠르게 움직이지 않아 많이 힘드셨을 것 같아요.</p><p><strong>인지 (주의·집중) 영역</strong><br/>\'생각의 조종실\'에 에너지가 부족해진 것과 같아요. 집중력의 힘이 약해지고, 명확하게 상황을 판단하고 결정하는 사고력이 무뎌진 상태를 의미해요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• 머릿속 생각을 밖으로 꺼내기✍️</strong><br/>해야 할 일, 기억해야 할 약속을 스마트폰 메모장이나 수첩에 바로바로 적어보세요.</p><p><strong>• \'멀티태스킹\' 금지, \'싱글태스킹\' 시작</strong><br/>한 번에 하나의 작업만 뇌에 부여해서 부담을 줄여주세요.</p><p><strong>• \'뽀모도로 기법\'으로 집중력 리듬 만들기🍅</strong><br/>25분 집중하고 5분 휴식하는 것을 한 세트로 정해두고 일해 보세요.</p><p><strong>• 전문가의 도움을 고려해 보기</strong><br/>\'브레인 포그\' 현상이 오랫동안 지속된다면 전문가와 상의해 보는 것이 좋아요.</p>'
        ],
        5: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_soso.png',
          '동굴 속 휴식 유형 ⛺',
          '<p>사람들과 어울리고 일상을 꾸려나가는 데 사용하는 에너지가 많이 소진된 상태로 보여요.</p><p><strong>사회·역할기능 (대인관계, 일상기능) 영역</strong><br/>\'사회적 배터리\'가 방전된 것과 비슷해요. 다른 사람과 관계를 맺고 유지하는 것 자체가 피곤하게 느껴져서 혼자만의 시간이 절실해질 수 있어요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'해야 할 일\' 대신 \'해낸 일\' 목록 만들기</strong><br/>잠들기 전 오늘 해낸 아주 사소한 일들을 적어보세요.</p><p><strong>• 관계를 위한 \'가장 작은\' 노력만 해보기</strong><br/>가장 편한 사람에게 이모티콘 하나를 보내거나, 재미있는 영상 링크를 공유해보세요.</p><p><strong>• 거절과 경계 설정 연습하기</strong><br/>\"오늘은 좀 피곤해서 어려울 것 같아\"라고 솔직하게 표현하는 연습을 해보세요.</p>'
        ],
        6: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_bad.png',
          '젖은 솜이불 유형 🛌',
          '<p>요즘 마음과 몸이 동시에 방전되어, 일상을 이어나가는 것 자체가 무척 힘겹게 느껴지실 것 같아요.</p><p><strong>마음과 몸의 악순환</strong><br/>마음의 활력이 떨어져 우울하고 무기력한 감정이 계속되니, 몸도 그에 반응하여 잠을 설치거나, 입맛이 없고, 피로감이 극심해지는 악순환이 반복될 수 있어요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'완벽한 하루\'가 아닌 \'하나의 루틴\'☀️</strong><br/>아침에 일어나는 시간만이라도 매일 비슷하게 지켜보세요.</p><p><strong>• \'기분 전환\'이 아닌 \'감각 전환\'</strong><br/>따뜻한 물로 샤워하기, 좋아하는 향의 핸드크림 바르기 등 몸의 감각을 부드럽게 깨워보세요.</p><p><strong>• 5분 햇볕 + 5분 걷기</strong><br/>집 앞에서 5분간 햇볕을 쬐고, 아주 느린 속도로 5분만 걸어보세요.</p><p><strong>• 전문가의 도움 적극적으로 고려하기</strong><br/>마음과 몸이 함께 보내는 SOS 신호가 강할 때는, 전문가의 도움을 받는 것이 가장 안전하고 빠른 회복의 길일 수 있어요.</p>'
        ],
        7: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_bad.png',
          '마음따로 머리따로 유형 💔',
          '<p>요즘 마음 따로, 머리 따로 움직이는 듯한 느낌에 많이 답답하고 힘드셨을 것 같아요.</p><p><strong>감정과 생각의 악순환</strong><br/>마음이 우울하고 무기력한 감정을 처리하느라 너무 많은 에너지를 쓰고 있으니, 정작 무언가에 집중하고, 판단하고, 기억하는 데 쓸 에너지가 부족해지는 거예요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'생각 정리\'가 아닌 \'생각 비우기\'🧠</strong><br/>3분만 창밖의 풍경을 소리 없이 바라보거나, 가사 없는 음악 한 곡을 눈을 감고 들어보세요.</p><p><strong>• \'결정\'의 부담을 줄이는 \'단순화\' 전략</strong><br/>선택지를 2개로 줄이거나 아예 정해두세요. \'아침은 무조건 시리얼\'처럼요.</p><p><strong>• \'즐거움\'이 아닌 \'익숙함\'에서 안정 찾기</strong><br/>여러 번 봤던 영화나 드라마 다시 보기, 예전에 즐겨 듣던 앨범 전곡 듣기를 시도해보세요.</p><p><strong>• 전문가의 도움 적극적으로 고려하기</strong><br/>감정과 생각이 함께 길을 잃었을 때는, 전문가의 안내를 받는 것이 가장 효과적인 해결책일 수 있어요.</p>'
        ],
        8: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_bad.png',
          '커튼 친 방 유형 🪟',
          '<p>마음의 에너지가 고갈되면서, 다른 사람들과 관계를 맺고 일상을 꾸려나가는 힘까지 함께 약해진 상태인 것 같아요.</p><p><strong>마음과 세상의 단절</strong><br/>마음이 깊은 슬픔과 무기력감에 빠져 있으니, 다른 사람을 만나거나 일상적인 책임을 다하는 것이 어렵고 버겁게 느껴지는 거예요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'의무감\' 내려놓고 \'관찰자\' 되기🌳</strong><br/>카페 창가에 잠시 앉아 사람들을 구경하거나, 공원 벤치에 앉아 지나가는 풍경을 바라보세요.</p><p><strong>• \'투두 리스트\' 대신 \'원 띵 리스트\'</strong><br/>\'오늘 딱 하나만 한다면?\'이라고 스스로에게 묻고, 가장 작고 쉬운 일 하나만 정해서 해보세요.</p><p><strong>• \'감정 표현\'이 아닌 \'상태 공유\'</strong><br/>\"나 오늘 에너지 없어\", \"조금 힘든 날이야\"처럼 지금의 상태만 짧게 공유해 보세요.</p><p><strong>• 전문가의 도움 적극적으로 고려하기</strong><br/>내면의 감정이 일상과 관계까지 잠식하고 있다면, 전문가의 도움을 통해 안전하게 다시 세상과 연결되는 다리를 놓을 수 있어요.</p>'
        ],
        9: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_bad.png',
          '저전력 모드 유형 🔌',
          '<p>요즘 몸의 컨디션 난조와 함께 머릿속이 뿌옇게 흐려지는 느낌 때문에 이중으로 힘드셨을 것 같아요.</p><p><strong>몸과 뇌의 동반 소진</strong><br/>몸의 기본적인 리듬이 깨지면서 충분한 재충전이 이루어지지 않으니, 뇌가 제 성능을 발휘하기 어려운 것은 어쩌면 당연한 일이에요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'두뇌 훈련\' 대신 \'몸의 리듬 훈련\'🌅</strong><br/>아침에 일어나는 시간을 일정하게 지키는 것에만 집중해 보세요.</p><p><strong>• \'복잡한 생각\'을 멈추는 \'단순한 감각\'</strong><br/>차가운 물에 손을 씻거나 얼음 한 조각을 쥐어보세요.</p><p><strong>• \'에너지 보충\'을 위한 \'마이크로 휴식\'</strong><br/>1시간에 한 번, 5분만이라도 하던 일을 멈추고 눈을 감거나 창밖을 멍하니 바라보세요.</p><p><strong>• 전문가의 도움 적극적으로 고려하기</strong><br/>몸과 뇌의 기능이 함께 저하되는 현상이 지속된다면, 전문가와 함께 그 원인을 찾아보는 것이 중요해요.</p>'
        ],
        10: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_bad.png',
          '강제 동면 유형 💤',
          '<p>몸의 에너지가 바닥나면서, 일상을 꾸리고 사람들과 관계를 맺는 외부 활동까지 멈춰버린 듯한 이중의 어려움을 겪고 계신 것 같아요.</p><p><strong>몸과 일상의 동반 셧다운</strong><br/>우리 몸은 삶의 모든 활동을 가능하게 하는 \'배터리\'와 같아요. 현재 잠을 제대로 못 자거나, 식사를 거르거나, 극심한 피로에 시달리면서 이 배터리가 거의 방전된 상태인 거죠.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'할 일\'을 정하기 전 \'쉴 일\'부터 정하기🛌</strong><br/>\'오후 2시부터 20분은 눕기\'처럼 쉬는 시간을 먼저 정해보세요.</p><p><strong>• \'사회 활동\'이 아닌 \'생존 활동\'에 집중하기</strong><br/>\'하루 한 끼는 꼭 먹기\', \'잠옷은 갈아입기\'처럼 생존에 필요한 최소한의 활동에만 집중해보세요.</p><p><strong>• \'연결\'을 위한 가장 쉬운 방법, \'수동적 연결\'</strong><br/>라디오를 틀어놓거나, 좋아하는 유튜버의 잔잔한 방송을 배경음악처럼 들어보세요.</p><p><strong>• 전문가의 도움 적극적으로 고려하기</strong><br/>몸의 기반이 무너져 일상 전체가 흔들릴 때는, 전문가의 도움을 받아 \'기초 공사\'를 다시 점검하는 것이 중요해요.</p>'
        ],
        11: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_bad.png',
          '길 잃은 여행자 유형 🛣️',
          '<p>요즘 머릿속이 복잡하고 생각이 명확하지 않아서, 일상을 꾸리거나 사람들을 만나는 데까지 어려움이 번진 것 같아요.</p><p><strong>생각과 삶의 악순환</strong><br/>머릿속이 안개 낀 것처럼 집중이 잘 안되고 판단이 흐려지니, 일이나 집안일이 자꾸 밀리고 사람들과의 약속이나 대화도 부담스럽게 느껴지는 거예요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'모든 일\'을 기억하려 말고 \'한 가지\'만 기록하기📝</strong><br/>내일 해야 할 가장 중요한 일, 딱 한 가지만 자기 전에 메모지에 적어두세요.</p><p><strong>• \'완벽한 소통\' 대신 \'솔직한 양해\' 구하기</strong><br/>\"요즘 내가 집중이 잘 안돼서, 대화하다가 놓치거나 약속을 깜빡할 수도 있어\"라고 미리 이야기해보세요.</p><p><strong>• \'큰 목표\'를 \'작은 행동\'으로 쪼개기</strong><br/>\'방 청소\'를 \'1. 쓰레기 버리기, 2. 옷 개기, 3. 바닥 닦기\'로 나누고 그중 하나만 해보세요.</p><p><strong>• 전문가의 도움 적극적으로 고려하기</strong><br/>뇌의 운영체제와 외부 활동이 동시에 어려움을 겪을 때는, 전문가의 도움을 받아 전체 시스템을 점검하는 것이 효과적이에요.</p>'
        ],
        12: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_worst.png',
          '내부 시스템 방전 유형 🔋',
          '<p>지금 마음과 몸, 그리고 생각하는 힘까지 모든 에너지가 완전히 방전된 <strong>\'시스템 전체의 셧다운\'</strong> 상태를 경험하고 계신 것 같아요.</p><p><strong>마음, 몸, 뇌의 총체적 소진</strong><br/>마음, 몸, 뇌는 서로 긴밀하게 연결된 하나의 시스템이에요. 지금은 어느 한 곳의 문제가 아니라, 세 가지 모두가 서로에게 영향을 주며 기능이 저하되는 깊은 악순환에 들어선 것으로 보여요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'무언가 하기\'가 아닌 \'아무것도 하지 않기\' 허락하기</strong><br/>죄책감 없이 하루 종일 누워있어도 괜찮아요. 지금은 회복을 위한 \'대기 모드\'가 필요한 시간이에요.</p><p><strong>• 몸을 위한 \'최소한의 신호\' 보내기</strong><br/>하루에 딱 한 번, 따뜻한 물 한 잔을 마시거나, 5분만 창문을 열어 바깥 공기를 쐬어보세요.</p><p><strong>• 전문가의 도움을 \'최우선 순위\'로 두기- 가장 중요하고 시급한 부분입니다.</strong><br/>가까운 정신건강의학과나 신뢰할 수 있는 심리상담센터에 연락해서 도움을 요청하는 것을 가장 중요한 첫 번째 행동으로 삼아주세요.</p>'
        ],
        13: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_worst.png',
          '세상과의 거리두기 유형 👋',
          '<p>마음과 몸의 에너지가 모두 고갈되어, 일상생활과 관계를 이어나가는 외부 활동까지 멈춰버린, 총체적인 어려움을 겪고 계신 것 같아요.</p><p><strong>마음, 몸, 삶의 동반 셧다운</strong><br/>마음의 힘이 약해지자 몸의 리듬이 흔들리고, 결국 삶의 기반이 되는 일상과 관계까지 무너져 내리는 악순환을 경험하고 계신 것으로 보여요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'해야 할 일\' 목록 버리고, \'해도 괜찮은 일\' 하나만 남기기</strong><br/>하루 종일 아무것도 하지 않아도 괜찮아요. \'따뜻한 물 한 잔 마시기\'처럼 나를 돌보는 가장 작은 행동 딱 하나만 \'해도 괜찮은 일\'로 남겨두세요.</p><p><strong>• \'혼자 해결하기\'를 멈추고, \'도움 요청\' 신호 보내기</strong><br/>가장 신뢰하는 단 한 사람에게 \"나 지금 너무 힘들어. 도와줘\" 이 한 마디만 문자로 보내보세요.</p><p><strong>• 전문가의 도움을 \'최우선 순위\'로 두기- 가장 중요하고 시급한 부분입니다.</strong><br/>가까운 정신건강의학과에 방문하여 현재 상태를 정확히 점검하고, 무너진 리듬을 회복하기 위한 구체적인 도움을 받는 것을 주저하지 마세요.</p>'
        ],
        14: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_worst.png',
          '엉킨 실타래 유형 🧶',
          '<p>마음과 생각, 그리고 일상생활까지 삶의 여러 영역에서 동시에 어려움을 겪으며 무척 힘든 시간을 보내고 계신 것 같아요.</p><p><strong>감정, 생각, 삶의 악순환</strong><br/>마음은 기쁨과 의욕을 잃고 깊이 가라앉아 있고, 머리는 안개가 낀 것처럼 흐릿해서 집중과 판단이 어려우며, 삶은 일상과 관계의 책임이 버거워 멈춰버린 상태일 수 있어요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'생각\'과 \'행동\'을 대신해 줄 \'외부 장치\' 사용하기📌</strong><br/>\'내일 입을 옷 미리 꺼내두기\', \'알람에 약 먹을 시간 적어두기\'처럼 다음 행동을 위한 물리적인 준비를 해두세요.</p><p><strong>• \'복잡한 교류\' 대신 \'단순한 연결\' 시도하기</strong><br/>가장 편한 사람에게 의미 없는 이모티콘이나 웃긴 짤을 보내는 것처럼 아주 가벼운 소통을 시도해 보세요.</p><p><strong>• 전문가의 도움을 \'최우선 순위\'로 두기- 가장 중요하고 시급한 부분입니다.</strong><br/>가까운 정신건강의학과나 심리상담센터에 연락해서 전문가의 도움을 받는 것을 가장 중요한 일로 생각해주세요.</p>'
        ],
        15: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_worst.png',
          '기능 정지 번아웃 유형 ❤️‍🔥',
          '<p>몸과 생각, 그리고 일상생활이라는 삶의 세 가지 큰 기둥이 동시에 흔들리는 듯한 총체적인 어려움을 겪고 계신 것 같아요.</p><p><strong>몸, 뇌, 삶의 동반 셧다운</strong><br/>몸의 엔진이 꺼지면서 잠, 식욕, 에너지의 리듬이 깨지고, 생각의 내비게이션이 흐려져 집중하거나 판단하기 어려워지며, 결국 일상과 관계라는 바퀴마저 굴러가지 않는 악순환에 들어선 것으로 보여요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• \'모든 것\'을 회복하려 말고 \'한 가지\'만 바로잡기☀️</strong><br/>\'아침 기상 시간\' 하나만이라도 매일 비슷하게 지켜보세요.</p><p><strong>• \'생각\'을 멈추고 \'몸\'을 느끼는 1분</strong><br/>딱 1분만 발바닥에 모든 신경을 집중해보세요.</p><p><strong>• 전문가의 도움을 \'최우선 순위\'로 두기- 가장 중요하고 시급한 부분입니다.</strong><br/>가까운 정신건강의학과나 심리상담센터에 방문하여 현재 상태를 정확히 알리고, 삶의 질서를 되찾기 위한 구체적인 계획을 함께 세워나가는 것을 가장 시급한 일로 여겨주세요.</p>'
        ],
        16: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_worst.png',
          '종합 번아웃 유형 🚨',
          '<p>지금 삶의 모든 영역에서 거대한 파도에 휩쓸리는 것처럼, 감당하기 어려운 총체적인 위기를 겪고 계신 것 같아요.</p><p><strong>삶의 시스템 전체가 멈춘 상태</strong><br/>마음은 짙은 우울감에 잠겨 즐거움과 의욕을 모두 잃었고, 몸은 잠과 식사, 에너지의 리듬이 완전히 무너졌으며, 생각은 안개가 낀 것처럼 흐려져 집중과 판단이 어렵고, 일상은 관계와 역할의 끈이 끊어져 완전히 멈춰버렸을 수 있어요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• 가장 중요: \'스스로 해결하기\'를 멈추고 \'전문가에게 도움 요청하기\'🆘</strong><br/>지금 이 글을 읽는 즉시, 해야 할 가장 중요하고 유일한 일은 도움을 요청하는 것입니다.</p><p><strong>방법 1:</strong> 가까운 정신건강의학과에 바로 전화해서 가장 빠른 진료를 예약하세요.<br/><strong>방법 2:</strong> 지역 정신건강복지센터(📞1577-0199)에 연락하여 상담 및 연계 서비스를 문의하세요.<br/><strong>방법 3:</strong> 가장 신뢰하는 사람에게 지금 이 상황을 알리고, 병원에 함께 가달라고 부탁하세요.</p><p><strong>• 도움받기 전까지, \'오늘 하루를 버티는\' 최소한의 생존 규칙</strong><br/>스스로를 해치고 싶은 생각이 든다면, 자살예방 상담전화(📞109)나 119에 반드시 연락해야 해요.</p>'
        ],
        17: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_worst.png',
          '마음의 긴급 SOS 유형 🆘',
          '<p>삶을 끝내고 싶다는 생각이 들 만큼, 현재 매우 큰 고통을 겪고 계신 것으로 보여요.</p><p>이러한 생각은 비난받을 일이 아니라, 감당하기 힘든 고통 속에서 마음이 보내는 가장 절박한 <strong>구조 신호</strong>예요. 중요한 점은, 이 생각이 \'삶\'을 끝내고 싶다기보다 \'지금의 끔찍한 고통\'을 끝내고 싶다는 마음의 외침이라는 거예요.</p><p><strong>가장 중요하고 시급한 행동</strong></p><p><strong>• 1순위: 전문가와 즉시 연결되기🆘</strong><br/>• 자살예방 상담전화: 📞 109<br/>• 정신건강 위기상담전화: 📞 1577-0199<br/>• 긴급한 위기 상황일 경우: 📞 119</p><p><strong>• 신뢰하는 사람에게 신호 보내기</strong><br/>\"나 지금 너무 힘들어. 도움이 필요해.\"</p><p><strong>• 스스로와 약속하기</strong><br/>\'어떤 일이 있어도 오늘 하루는 나를 해치지 않겠다\'고 약속해주세요.</p><p>지금의 고통이 영원할 것처럼 느껴져도, 절대 그렇지 않아요. 전문가의 도움을 받으면 반드시 지금의 위기에서 벗어날 수 있습니다. <strong>부디, 지금 바로 도움을 요청하세요.</strong></p>'
        ],
        18: [
          'https://assets.trost.co.kr/images/promotion/channel/img_process_soso.png',
          '마음 환기 필요 유형 🍃',
          '<p>어느 한쪽으로 크게 치우치진 않았지만, 전반적으로 마음의 에너지가 조금 소진된 상태인 것 같아요.</p><p>마치 쨍하게 맑은 날은 아니지만, 그렇다고 폭풍우가 몰아치는 날도 아닌, 약간의 구름이 낀 날씨와 비슷해요. ☁️ 일상 속 스트레스나 작은 걱정들이 쌓여 마음의 컨디션이 조금 저하된 상태일 수 있어요.</p><p style="margin-top: 30px;padding-top: 20px;border-top: 1px solid #E0E0E0;"><strong style="font-size: 20px;">💡 Self-Help 큐레이션</strong></p><p><strong>• 하루 10분, \'멍때리기\' 시간 갖기</strong><br/>스마트폰 없이 창밖을 보거나, 좋아하는 음악을 들으며 잠시 아무것도 하지 않는 시간을 가져보세요.</p><p><strong>• 오늘 좋았던 일, \'한 가지\'만 떠올리기</strong><br/>잠들기 전, 오늘 하루 있었던 일 중에 아주 사소한 것이라도 좋으니 기분 좋았던 순간을 하나만 떠올려 보세요.</p><p><strong>• 몸을 가볍게 움직여 생각 환기하기</strong><br/>점심시간에 15분 정도 가볍게 산책하거나, 잠들기 전 간단한 스트레칭을 해보세요.</p>'
        ]
      },
      guide: '* 본 우울증 자가진단 검사는 주 1회 평가를 권장하며, ‘심한 우울 상태’ 결과가 2주 이상 나올 경우 전문가와의 상의를 권장합니다. 입시와 같이 환경적으로 부정적인 상황에 처한 경우 테스트 결과가 상향되어 나올 수 있습니다.',
      'guide-last': '혹시 우울증일까? 걱정된다면...<br/>트로스트에서 전문가에게 상담받으세요',
      type: 'finish'
    }
  ]
};

const reportAdKeywords = {
  female: {
    '10대 미만': '친구, 학교공부',
    '10대': '진로, 대인관계',
    '20대': '연애, 무기력',
    '30대': '일/직장, 결혼',
    '40대': '경제 상황, 자녀/가족',
    '50대': '노후 준비, 건강',
    '60대 이상': '노후 준비, 건강'
  },
  male: {
    '10대 미만': '친구, 학교공부',
    '10대': '진로, 대인관계',
    '20대': '연애, 무기력',
    '30대': '일/직장, 결혼',
    '40대': '경제 상황, 자녀/가족',
    '50대': '노후 준비, 건강',
    '60대 이상': '노후 준비, 건강'
  },
  others: {
    '10대 미만': '친구, 학교공부',
    '10대': '진로, 대인관계',
    '20대': '연애, 무기력',
    '30대': '일/직장, 결혼',
    '40대': '경제 상황, 자녀/가족',
    '50대': '노후 준비, 건강',
    '60대 이상': '노후 준비, 건강'
  }
};

const setQuestionAction = (paramQuestionNumber = 0, point = 0, el = '', paramShareID = '') => {
  pointEl = '';
  answerEl = '';
  answerString = [];

  // point를 숫자로 변환 (문자열 "5"를 숫자 5로 변환)
  const numericPoint = parseInt(point, 10) || 0;

  // console.log(`=== setQuestionAction 호출: paramQuestionNumber=${paramQuestionNumber}, point="${point}", numericPoint=${numericPoint} ===`);

  // 점수 저장 로직
  // 1200번 줄에서 setQuestionAction(paramQuestionNumber, answerString[1])로 호출됨
  // paramQuestionNumber는 현재 표시 중인 질문 번호 (1=첫질문, 2=둘째질문, ..., 37=37번질문)
  // question 배열: [0]=placeholder, [1]=질문1, [2]=질문2, ..., [37]=질문37
  // paramQuestionNumber가 이미 배열 인덱스와 일치하므로 그대로 사용!
  if (numericPoint > 0 && paramQuestionNumber > 0) {
    const questionIndex = paramQuestionNumber;
    const currentQuestion = questionData.question[questionIndex];

    if (currentQuestion && Array.isArray(currentQuestion) && currentQuestion.length >= 4) {
      const category = currentQuestion[3];

      if (category && categoryScores[category] !== undefined) {
        categoryScores[category].push(numericPoint);
        // console.log(`Q${questionIndex}: "${category}" = ${numericPoint}점`);

        // 자살사고일 때 특별 로그
        if (category === '자살사고') {
          // console.log(`🚨 자살사고 점수 저장! 점수: ${numericPoint}, 배열:`, categoryScores['자살사고']);
        }
      }
    }
  }

  paramQuestionNumber += 1;
  totalPoint += numericPoint;

  if (questionData.question[paramQuestionNumber].type === 'finish') {
    document.getElementById('channel-question').style.display = 'none';

    const channelUserInfo = document.getElementById('channelUserInfo');
    getUserDataInTest(channelUserInfo, resultData, el, paramShareID, ({
                                                                        gender, age, nickname
                                                                      }, testResData) => {
      shareID = (paramShareID) || ((Object.keys(testResData).length) ? testResData.data.shareID : '');

      channelUserInfo.classList.add('is-hide');
      document.getElementById('channel-finish').style.display = 'block';
      cashWalkBridgeConfig.firebaseEvent(firebaseEventKey.trost_mindcheck_result_view({ type: 'depression' }));

      // 닉네임
      document.getElementById('js-test-nickname').innerHTML = (nickname) ? `${nickname}님의` : '지금 나의';

      // 광고 메시지 제작
      let totalTestGenderGuide = '';
      if (age === '0 ~ 9') totalTestGenderGuide = '10대 미만';
      if (age === '0 ~ 19') totalTestGenderGuide = '10대';
      if (age === '10 ~ 19') totalTestGenderGuide = '10대';
      if (age === '20 ~ 29') totalTestGenderGuide = '20대';
      if (age === '20 ~ 30') totalTestGenderGuide = '20대';
      if (age === '30 ~ 39') totalTestGenderGuide = '30대';
      if (age === '31 ~ 40') totalTestGenderGuide = '30대';
      if (age === '40 ~ 49') totalTestGenderGuide = '40대';
      if (age === '41 ~ 50') totalTestGenderGuide = '40대';
      if (age === '50 ~ 59') totalTestGenderGuide = '50대';
      if (age === '51 ~ 60') totalTestGenderGuide = '50대';
      if (age === '60 ~') totalTestGenderGuide = '60대 이상';
      if (age === '61 ~') totalTestGenderGuide = '60대 이상';

      let genderText = (gender === 'male') ? '남성' : (gender === 'female') ? '여성' : '기타 성별';

      if (!totalTestGenderGuide) {
        totalTestGenderGuide = '20대';
        genderText = '여성';
        gender = 'female';
      }

      document.getElementById('report-ad-gender-age').innerHTML = `${totalTestGenderGuide} ${genderText}`;
      document.getElementById('report-ad-keywords').innerHTML = reportAdKeywords[gender][totalTestGenderGuide];

      if (document.getElementById('report-ad-gender-age').innerHTML === '' && document.getElementById('report-ad-keywords').innerHTML === '') {
        document.getElementsByClassName('report-ad')[0].style.display = 'none';
      }

      // if (isApp) {
      //   for (let i = 0; i < document.getElementsByClassName('js_btn-ad').length; i += 1) {
      //     document.getElementsByClassName('js_btn-ad')[i].addEventListener('click', () => {
      //       locationMovement('findPartners', {});
      //     });
      //   }
      //
      //   document.getElementsByClassName('js_btn-out-ad')[0].addEventListener('click', () => {
      //     locationMovement('internal_web', {
      //       title: '마음 상태 점검',
      //       redirectUrl: '/service/test/',
      //     });
      //   });
      // }

      // if (!isApp || getInfoOfDeviceOS() !== 'ios') {
      //   document.getElementsByClassName('wrapper-partner-recommend')[1].innerHTML = `<div class="google-ad__wrapper" style="width: 100%;max-width: 650px;margin: 24px auto;height: auto;">
      //   <ins class="adsbygoogle"
      //       style="display:block; text-align:center;"
      //       data-ad-layout="in-article"
      //       data-ad-format="fluid"
      //       data-ad-client="ca-pub-9240703521253693"
      //       data-ad-slot="2308802246"></ins>
      //   </div>${document.getElementsByClassName('wrapper-partner-recommend')[1].innerHTML}`;
      //
      //   (adsbygoogle = window.adsbygoogle || []).push({});
      // }
      // 광고 메시지 제작

      // 결과 공유
      document.getElementsByClassName('share-fb')[1].addEventListener('click', () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=https://trost.co.kr/promotion/channel/depressive-check-program/?shareTotalPoint=${totalPoint}&shareId=${shareID}`);
      });

      document.getElementsByClassName('share-twt')[1].addEventListener('click', () => {
        window.open(`https://twitter.com/intent/tweet?text=우울증_지수_진단_체크하기&url=https://trost.co.kr/promotion/channel/depressive-check-program/?shareTotalPoint=${totalPoint}&shareId=${shareID}`);
      });

      document.getElementsByClassName('share-fb-message')[1].addEventListener('click', () => {
        window.open(`https://www.facebook.com/dialog/send?app_id=648514988614114&link=https://trost.co.kr/promotion/channel/depressive-check-program/?shareTotalPoint=${totalPoint}&shareId=${shareID}&redirect_uri=https://trost.co.kr/promotion/channel/depressive-check-program/?shareTotalPoint=${totalPoint}&shareId=${shareID}`);
      });
      //

      // 결과 유형 결정
      const resultKey = determineResultType();

      // document.getElementById('finish-title').innerHTML = questionData.question[paramQuestionNumber].title;
      // document.getElementById('finish-point').innerHTML = `<span>${totalPoint}</span>점`;
      // document.getElementById('finish-guide').innerHTML = questionData.question[paramQuestionNumber].guide;
      // document.getElementById('finish-last-guide').innerHTML = questionData.question[paramQuestionNumber]['guide-last'];

      // if (questionData.question[paramQuestionNumber].content[resultKey] && questionData.question[paramQuestionNumber].content[resultKey][4]) {
      //   document.getElementById('finish-point').innerHTML += `<img src='${questionData.question[paramQuestionNumber].content[resultKey][4]}'/>`;
      // }

      if (questionData.question[paramQuestionNumber].content[resultKey]) {
        document.getElementById('finish-point-content').innerHTML = questionData.question[paramQuestionNumber].content[resultKey][1];
        document.getElementById('finish-content').innerHTML = questionData.question[paramQuestionNumber].content[resultKey][2];
      } else {
        // 기본 결과 (결과 콘텐츠가 아직 없는 경우)
        document.getElementById('finish-point-content').innerHTML = '결과 분석 중';
        document.getElementById('finish-content').innerHTML = '<p>결과 유형: ' + resultKey + '</p>';
      }
      // document.getElementById('finish-partner-content').innerHTML = questionData.question[paramQuestionNumber].content[resultKey][2];
      // document.getElementById('finish-image').src = questionData.question[paramQuestionNumber].content[resultKey][0];

      // document.body.style.background = '#25333c';
      document.body.scrollIntoView();

      if (shareTotalPoint) {
        document.getElementsByClassName('re')[0].innerHTML = '나의 테스트 결과가 궁금하다면?';
        document.getElementsByClassName('re')[0].setAttribute('onclick', 'window.location.href = \'/promotion/channel/depressive-check-program/\';');
      }

      //
      EmblaCarousel(document.getElementsByClassName('reviews-el_embla')[0], curationOptions);

      //
      for (let i = 0; i < document.getElementsByClassName('js_btn-find-partners').length; i += 1) {
        document.getElementsByClassName('js_btn-find-partners')[i].style.display = 'block';

        document.getElementsByClassName('js_btn-find-partners')[i].addEventListener('click', () => {
          const partnerId = document.getElementsByClassName('js_btn-find-partners')[i].classList[1];

          if (isApp) {
            if (partnerId) {
              locationMovement('findPartners', { id: partnerId });
            } else {
              locationMovement('findPartners', {});
            }
          } else {
            window.location.href = `/mobile/partner/detail/?partnerID=${partnerId}`;
          }
        });
      }

      if (isApp) {
        document.getElementsByClassName('a_btn_last_guide_counseling_guide')[0].setAttribute('target', '_self');
        document.getElementsByClassName('a_btn_last_guide_counseling_guide')[0].setAttribute('href', 'hctrost://webview?title=상담 가이드북&url=https://humartcompany.notion.site/6-A-to-Z-f5cb4991953e4fcd8157c67a1a1ff09d');
        // document.getElementsByClassName('a_btn_last_guide_payback')[0].setAttribute('target', '_self');
        // document.getElementsByClassName('a_btn_last_guide_payback')[0].setAttribute('href', `hctrost://webview?title=상담만족 보상제도&url=https://${window.location.host}/promotion/payback/`);

        document.getElementsByClassName('a_btn_last_app_download')[0].setAttribute('target', '_self');
        document.getElementsByClassName('a_btn_last_app_download')[0].setAttribute('href', 'hctrost://trostCuration/;hctrost://home/;');
        document.getElementsByClassName('a_btn_last_guide_sounds_therapy')[0].setAttribute('target', '_self');
        document.getElementsByClassName('a_btn_last_guide_sounds_therapy')[0].setAttribute('href', 'hctrost://trostCuration/;hctrost://home/;');
        // document.getElementsByClassName('a_btn_last_guide_tests')[0].setAttribute('target', '_self');
        // document.getElementsByClassName('a_btn_last_guide_tests')[0].setAttribute('href', 'hctrost://trostCuration/;hctrost://home/;');
        document.getElementsByClassName('a_btn_last_guide_ai')[0].setAttribute('target', '_self');
        document.getElementsByClassName('a_btn_last_guide_ai')[0].setAttribute('href', 'hctrost://trostCuration/;hctrost://home/;');

        // document.getElementsByClassName('btn_fixed')[0].innerHTML = '내 고민에 딱! 맞는 상담사 추천받기 ➡️';
      }

      //
      document.getElementsByClassName('area_fixed')[0].style.display = 'block';
      document.getElementById('appDownloadFloatingPopup').style.bottom = '70px';
      // document.getElementById('appDownloadFloatingPopup').style.left = 'auto';
      // document.getElementById('appDownloadFloatingPopup').style.right = '20px';

      document.getElementsByClassName('btn_fixed')[0].addEventListener('click', () => {
        if (isApp) {
          locationMovement('internal_web', {
            title: '',
            redirectUrl: '/service/counseling/coordinator/'
          });
        } else {
          window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
        }
      });

      // window.addEventListener('scroll', () => {
      //   if (window.pageYOffset < document.getElementsByClassName('el_title')[0].offsetTop - 100) {
      //     document.getElementsByClassName('redirect-curation')[0].style.display = 'none';
      //   } else {
      //     document.getElementsByClassName('redirect-curation')[0].style.display = 'block';
      //   }
      // });

      // document.getElementById('js-redirect-curation-coupon').addEventListener('click', () => {
      //   window.scrollTo({
      //     behavior: 'smooth',
      //     left: 0,
      //     top: document.getElementsByClassName('curation-div')[0].offsetTop - 60,
      //   });
      // });
      //
      // document.getElementById('js-redirect-curation-partners-list').addEventListener('click', () => {
      //   window.scrollTo({
      //     behavior: 'smooth',
      //     left: 0,
      //     top: document.getElementsByClassName('el_title')[3].offsetTop - 60,
      //   });
      // });

      //
      if (document.getElementsByClassName('counseling-intensive-course-el')[1]) {
        requestGET(`${OLD_API_URL}/trostCuration/v2/?content=curationIntensiveCourse`, (status, resData) => {
          if (!status) {
            return false;
          }

          const slideData = resData.data;
          let slideDataEl = '';

          slideData.forEach((item) => {
            if (isApp) {
              slideDataEl += `<div class="embla__slide" onclick="window.location.href = '/mobile/curation-course/?course_id=${item.courseId}&isApp=1&accessToken=${accessToken}&accessTokenExpiredAt=${accessTokenExpiredAt}&refreshToken=${refreshToken}&refreshTokenExpiredAt=${refreshTokenExpiredAt}';"><img alt="${item.courseTitle} 배너" src="${item.courseThumbnailImage}"></div>`;
            } else {
              slideDataEl += `<div class="embla__slide" onclick="window.location.href = '/mobile/curation-course/?course_id=${item.courseId}';"><img alt="${item.courseTitle} 배너" src="${item.courseThumbnailImage}"></div>`;
            }
          });

          if (slideDataEl) {
            document.getElementsByClassName('counseling-intensive-course-el')[1].innerHTML = `<div class="embla__container">${slideDataEl}</div>`;
            EmblaCarousel(document.getElementsByClassName('counseling-intensive-course-el')[1], {
              dragFree: false,
              loop: true,
              startIndex: 0
            });
          }
        });
      }

      if (document.getElementsByClassName('counseling-tests-el')[1]) {
        requestGET(`${OLD_API_URL}/trostCuration/v2/?content=counselingTests`, (status, resData) => {
          if (!status) {
            return false;
          }

          const slideData = resData.data;
          let slideDataEl = '';

          slideData.forEach((item) => {
            if (isApp) {
              slideDataEl += `<div class="embla__slide" onclick="window.location.href = '/mobile/curation-test/?content_link_id=${item.contentLinkId}&isApp=1&accessToken=${accessToken}&accessTokenExpiredAt=${accessTokenExpiredAt}&refreshToken=${refreshToken}&refreshTokenExpiredAt=${refreshTokenExpiredAt}';"><img src="${item.thumbnailImage}" alt="${item.title} 배너"/><p>${item.title}</p></div>`;
            } else {
              slideDataEl += `<div class="embla__slide" onclick="window.location.href = '/mobile/curation-test/?content_link_id=${item.contentLinkId}';"><img src="${item.thumbnailImage}" alt="${item.title} 배너"/><p>${item.title}</p></div>`;
            }
          });

          if (slideDataEl) {
            document.getElementsByClassName('counseling-tests-el')[1].innerHTML = `<div class="embla__container">${slideDataEl}</div>`;
            EmblaCarousel(document.getElementsByClassName('counseling-tests-el')[1], {
              dragFree: false,
              loop: true,
              startIndex: 0
            });
          }
        });
      }

      // 전체 검사 결과 완료 >> 유료화
      // document.getElementById('blur-el').style.display = 'block';
      //
      // // document.getElementsByClassName('finish-point-guide')[0].style.filter = 'blur(15px)';
      // for (let i = 0; i < document.getElementById('finish-content').getElementsByTagName('span').length; i += 1) {
      //   document.getElementById('finish-content').getElementsByTagName('span')[i].style.filter = 'blur(15px)';
      // }
      //
      // document.getElementsByClassName('report-ad')[0].style.filter = 'blur(15px)';
      // document.getElementsByClassName('re')[0].style.filter = 'blur(15px)';
      // document.getElementsByClassName('wrapper-partner-recommend')[0].style.filter = 'blur(15px)';
      // document.getElementsByClassName('wrapper-partner-recommend')[1].style.filter = 'blur(15px)';
      // document.getElementsByClassName('reviews-el')[0].style.filter = 'blur(15px)';
      //
      // if (shareID) {
      //   requestGET(`${OLD_API_URL}/payments/test/?testShareId=${shareID}&testType=depressive-check-program`, (status, resData) => {
      //     if (!status) {
      //       return false;
      //     }
      //
      //     if (resData.result && resData.data.isPaid) {
      //       document.getElementById('blur-el').style.display = 'none';
      //
      //       // document.getElementsByClassName('finish-point-guide')[0].style.filter = 'none';
      //       for (let i = 0; i < document.getElementById('finish-content').getElementsByTagName('span').length; i += 1) {
      //         document.getElementById('finish-content').getElementsByTagName('span')[i].style.filter = 'none';
      //       }
      //
      //       document.getElementsByClassName('report-ad')[0].style.filter = 'none';
      //       document.getElementsByClassName('re')[0].style.filter = 'none';
      //       document.getElementsByClassName('wrapper-partner-recommend')[0].style.filter = 'none';
      //       document.getElementsByClassName('wrapper-partner-recommend')[1].style.filter = 'none';
      //       document.getElementsByClassName('reviews-el')[0].style.filter = 'none';
      //     }
      //
      //     document.getElementById('js-testCount').innerHTML = resData.data.testCount;
      //
      //     document.getElementById('js-payment_btn').addEventListener('click', () => {
      //       const iamportUserId = (window.location.host === 'trost.co.kr' || window.location.host === 'www.trost.co.kr') ? 'imp42908814' : 'imp28624789';
      //       const orderId = `test_${shareID}`;
      //       const { IMP } = window;
      //
      //       IMP.init(iamportUserId);
      //       IMP.request_pay({
      //         pg: 'html5_inicis',
      //         pay_method: 'card',
      //         merchant_uid: orderId,
      //         name: '트로스트 심리검사',
      //         amount: 900,
      //         buyer_name: '',
      //         buyer_email: '',
      //         currency: 'KRW',
      //         m_redirect_url: `${window.location.origin}/promotion/channel/depressive-check-program/?shareTotalPoint=${totalPoint}&shareId=${shareID}&isPaid=1`,
      //         digital: true,
      //         app_scheme: 'hctrost',
      //       }, (response) => {
      //         if (response.success) {
      //           window.location.href = `/promotion/channel/depressive-check-program/?shareTotalPoint=${totalPoint}&shareId=${shareID}&isPaid=1`;
      //         } else {
      //           alert(`결제실패 : ${response.error_msg}`);
      //         }
      //       });
      //     });
      //
      //     if (isPaid) {
      //       requestPOST(`${OLD_API_URL}/payments/test/`, {
      //         testShareId: shareID,
      //         testType: 'depressive-check-program',
      //       }, (paidStatus, paidResData) => {
      //         if (paidResData.result && paidResData.data.isPaid) {
      //           document.getElementById('blur-el').style.display = 'none';
      //
      //           // document.getElementsByClassName('finish-point-guide')[0].style.filter = 'none';
      //           for (let i = 0; i < document.getElementById('finish-content').getElementsByTagName('span').length; i += 1) {
      //             document.getElementById('finish-content').getElementsByTagName('span')[i].style.filter = 'none';
      //           }
      //
      //           document.getElementsByClassName('report-ad')[0].style.filter = 'none';
      //           document.getElementsByClassName('re')[0].style.filter = 'none';
      //           document.getElementsByClassName('wrapper-partner-recommend')[0].style.filter = 'none';
      //           document.getElementsByClassName('wrapper-partner-recommend')[1].style.filter = 'none';
      //           document.getElementsByClassName('reviews-el')[0].style.filter = 'none';
      //         }
      //       });
      //     }
      //   });
      // }
    }, 'depression');
  } else {
    if (paramQuestionNumber > 1) {
      document.getElementsByClassName('question')[el].style.background = '#F57C00';
      document.getElementsByClassName('question')[el].style.color = 'transparent';
      document.getElementsByClassName('question')[el].classList.add('is-active');
    }

    for (let i = 0; i < questionData.question[paramQuestionNumber][1].length; i += 1) {
      answerString = questionData.question[paramQuestionNumber][1][i].split('/');
      answerEl += `<li class="question question_${paramQuestionNumber} ${paramQuestionNumber} ${questionData.question[paramQuestionNumber][1][i]}">${answerString[0]}</li>`;
    }

    document.getElementById('question-title').innerHTML = questionData.question[paramQuestionNumber][0];
    document.getElementById('question-answer').innerHTML = answerEl;

    if (paramQuestionNumber > 1) {
      document.getElementsByClassName('progress-bar-line')[0].style.width = `${(1 * paramQuestionNumber / (questionData.question.length - 1)) * 100}%`;
    }

    for (let i = 0; i < questionData.question[paramQuestionNumber][1].length; i += 1) {
      const onClickQuestionItem = () => {
        cashWalkBridgeConfig.firebaseEvent(firebaseEventKey.trost_mindcheck_answer_click({ type: 'depression' }));

        document.getElementsByClassName(`question_${paramQuestionNumber}`)[i].removeEventListener('click', onClickQuestionItem);

        answerString = questionData.question[paramQuestionNumber][1][i].split('/');
        resultData[resultData.length] = questionData.question[paramQuestionNumber][1][i].split('/');

        document.getElementsByClassName(`question_${paramQuestionNumber}`)[i].style.backgroundColor = '#FFF42E';
        document.getElementsByClassName(`question_${paramQuestionNumber}`)[i].style.border = '1px solid #FFF42E';
        document.getElementsByClassName(`question_${paramQuestionNumber}`)[i].style.color = '#333';

        window.setTimeout(() => setQuestionAction(paramQuestionNumber, answerString[1], i), 200);
      };

      document.getElementsByClassName(`question_${paramQuestionNumber}`)[i].addEventListener('click', onClickQuestionItem);
    }
  }
};

// 카카오링크 버튼을 생성합니다. 처음 한번만 호출하면 됩니다.
const sendLink = () => {
  Kakao.Link.sendCustom({
    templateId: 11353
  });
};

// 카카오링크 버튼을 생성합니다. 처음 한번만 호출하면 됩니다.
const sendLinkResult = () => {
  Kakao.Link.sendCustom({
    templateId: 11353
  });
};

shareTest.addEventListener('click', () => {
  sendLink();
});

shareResult.addEventListener('click', () => {
  sendLinkResult();
});

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('start-channel').addEventListener('click', () => {
    trostBridgeConfig.firebaseEvent({
      eventName: 'trost_mentalcare_tab',
      ...firebaseEventKey.trost_mentalcare_depressiontestpage_click({
        button: 'check',
      }),
    });

    document.getElementById('channel-introduce').style.display = 'none';
    document.getElementById('channel-question').style.display = 'block';
    cashWalkBridgeConfig.firebaseEvent(firebaseEventKey.trost_mindcheck_check_click({ type: 'depression' }));

    // document.getElementById('channel-question').innerHTML += `<div class="google-ad__wrapper" style="width: 100%;max-width: 650px;margin: 24px auto;height: auto;">
    //     <ins class="adsbygoogle"
    //          style="display:block"
    //          data-ad-client="ca-pub-9240703521253693"
    //          data-ad-slot="4845080646"
    //          data-ad-format="auto"
    //          data-full-width-responsive="true"></ins>
    // </div>`;
    //
    // (adsbygoogle = window.adsbygoogle || []).push({});

    return setQuestionAction(0, 0);
  });

  if (document.getElementsByClassName('counseling-intensive-course-el')[0]) {
    requestGET(`${OLD_API_URL}/trostCuration/v2/?content=curationIntensiveCourse`, (status, resData) => {
      if (!status) {
        return false;
      }

      const slideData = resData.data;
      let slideDataEl = '';

      slideData.forEach((item) => {
        if (isApp) {
          slideDataEl += `<div class="embla__slide" onclick="window.location.href = '/mobile/curation-course/?course_id=${item.courseId}&isApp=1&accessToken=${accessToken}&accessTokenExpiredAt=${accessTokenExpiredAt}&refreshToken=${refreshToken}&refreshTokenExpiredAt=${refreshTokenExpiredAt}';"><img alt="${item.courseTitle} 배너" src="${item.courseThumbnailImage}"></div>`;
        } else {
          slideDataEl += `<div class="embla__slide" onclick="window.location.href = '/mobile/curation-course/?course_id=${item.courseId}';"><img alt="${item.courseTitle} 배너" src="${item.courseThumbnailImage}"></div>`;
        }
      });

      if (slideDataEl) {
        document.getElementsByClassName('counseling-intensive-course-el')[0].innerHTML = `<div class="embla__container">${slideDataEl}</div>`;
        EmblaCarousel(document.getElementsByClassName('counseling-intensive-course-el')[0], {
          dragFree: false,
          loop: true,
          startIndex: 0
        });
      }
    });
  }

  if (document.getElementsByClassName('counseling-tests-el')[0]) {
    requestGET(`${OLD_API_URL}/trostCuration/v2/?content=counselingTests`, (status, resData) => {
      if (!status) {
        return false;
      }

      const slideData = resData.data;
      const slideDataEl = document.createElement('div'); // 문자열이 아니라 DOM 요소로 변경
      slideDataEl.classList.add('embla__container'); // embla__container 클래스 추가

      slideData.forEach((item) => {
        const slideElement = document.createElement('div');
        slideElement.classList.add('embla__slide');
        slideElement.innerHTML = `<img src="${item.thumbnailImage}" alt="${item.title} 배너"/><p>${item.title}</p>`;

        if (isApp) {
          slideElement.addEventListener('click', () => {
            trostBridgeConfig.firebaseEvent({
              eventName: 'trost_mentalcare_tab',
              ...firebaseEventKey.trost_mentalcare_depressiontestpage_click({
                banner: item.contentLinkId,
              }),
            });

            window.location.href = `/mobile/curation-test/?content_link_id=${item.contentLinkId}&isApp=1&accessToken=${accessToken}&accessTokenExpiredAt=${accessTokenExpiredAt}&refreshToken=${refreshToken}&refreshTokenExpiredAt=${refreshTokenExpiredAt}`;
          });
        } else {
          slideElement.setAttribute('onclick', `window.location.href = '/mobile/curation-test/?content_link_id=${item.contentLinkId}';`);
        }

        slideDataEl.appendChild(slideElement); // slideElement 추가
      });

      const parentEl = document.getElementsByClassName('counseling-tests-el')[0];
      parentEl.innerHTML = ''; // 기존 내용 제거
      parentEl.appendChild(slideDataEl); // 생성한 요소 추가

      EmblaCarousel(parentEl, {
        dragFree: false,
        loop: true,
        startIndex: 0
      });
    });
  }


  if (!isApp || (isApp && app !== 'cashwalk')) {
    document.getElementsByClassName('course-el')[0].style.display = 'block';
    document.getElementsByClassName('wrapper-partner-recommend')[0].style.display = 'block';
    document.getElementsByClassName('wrapper-partner-recommend')[1].style.display = 'block';
    document.getElementsByClassName('share')[1].style.display = 'block';
    document.getElementsByClassName('wrapper-guide-total-care')[0].style.display = 'block';
    // document.getElementsByClassName('mall-coupon')[0].style.display = 'block';
    document.getElementsByClassName('js_btn-out-ad')[0].style.display = 'block';
    document.getElementsByClassName('js_btn-out-ad')[1].style.display = 'block';
    document.getElementsByClassName('reviews-el')[0].style.display = 'block';
  }

  if (isApp) {
    document.getElementsByClassName('top-banners__wrapper')[0].style.display = app !== 'cashwalk' && 'block';
    document.getElementsByClassName('share')[1].style.top = '10px';
    document.getElementsByClassName('redirect-ai-coordinator')[0].addEventListener('click', () => {
      trostBridgeConfig.firebaseEvent({
        eventName: 'trost_mentalcare_tab',
        ...firebaseEventKey.trost_mentalcare_depressiontestpage_click({
          banner: 'recommend',
        }),
      });

      locationMovement('internal_web', {
        title: '',
        redirectUrl: '/service/counseling/coordinator/'
      });
    });

    if (isApp && getInfoOfDeviceOS() === 'ios') {
      for (let i = 0; i < document.getElementsByClassName('google-ad__wrapper').length; i += 1) {
        document.getElementsByClassName('google-ad__wrapper')[i].style.display = 'none';
      }
    }
  }

  // 결과 공유
  document.getElementsByClassName('share-fb')[0].addEventListener('click', () => {
    window.open('https://www.facebook.com/sharer/sharer.php?u=https://trost.co.kr/promotion/channel/depressive-check-program/');
  });

  document.getElementsByClassName('share-twt')[0].addEventListener('click', () => {
    window.open('https://twitter.com/intent/tweet?text=우울증_지수_진단_체크하기&url=https://trost.co.kr/promotion/channel/depressive-check-program/');
  });

  document.getElementsByClassName('share-fb-message')[0].addEventListener('click', () => {
    window.open('https://www.facebook.com/dialog/send?app_id=648514988614114&link=https://trost.co.kr/promotion/channel/depressive-check-program/&redirect_uri=https://trost.co.kr/promotion/channel/depressive-check-program/');
  });
  //

  if (shareTotalPoint && shareID) {
    document.getElementById('channel-introduce').style.display = 'none';
    setQuestionAction((questionData.question.length - 2), shareTotalPoint, 'SHARE', shareID);
  }
});
